<script lang="ts">

import RepeaterBlock
    from "../../../../../orange/broadband/demands/showcase/internetofferdetail/components/RepeaterBlock.vue";

interface BoxBenefitDto {
    label: string
    description: string
    icon?: string | null
}

interface InternetBoxBlockDTO {
    name: string
    visual?: any
    title: string
    firstAttribute: BoxBenefitDto
    secondAttribute: BoxBenefitDto
    thirdAttribute: BoxBenefitDto
    otherAttributes?: BoxBenefitDto[]
}

export default {
    name: "InternetLiveBoxBlock",
    components: {
        RepeaterBlock
    },
    props: {
        internetLiveBoxBlock: {
            type: Object as () => InternetBoxBlockDTO | null,
            default: null,
            required: false
        },
        repeaterBlocDto: {
            type: Object,
            default: null,
            required: false
        }
    }
}
</script>

<template>
    <div id="liveBoxContentTile" class="bg-dark">
        <div class="container-fluid pt-2 pt-md-3 pt-lg-4">
            <div class="row px-1 justify-content-center">
                <div class="col-auto">
                    <div class="d-flex justify-content-center text-center">
                        <h2 class="no-signature mb-0 text-white" v-html="internetLiveBoxBlock.title" />
                    </div>
                </div>
            </div>

            <div class="row px-1 pt-2 justify-content-md-center">
                <div class="col-12 col-lg-4 col-md-6 col-sm-6 p-0 pe-0 pe-md-1 pe-lg-2 pb-2 order-1 order-md-0 order-sm-0">
                    <p
                        v-if="internetLiveBoxBlock.firstAttribute.icon"
                        class="icon text-white mb-0"
                        :class="internetLiveBoxBlock.firstAttribute.icon"
                        style="font-size: 1.8rem"
                        aria-hidden="true"
                    />
                    <h3 class="h4 mb-0 pt-0 text-primary" v-html="internetLiveBoxBlock.firstAttribute.label" />
                    <p class="mb-0 text-white" v-html="internetLiveBoxBlock.firstAttribute.description" />
                </div>

                <div v-if="internetLiveBoxBlock.visual" class="col-12 col-lg-4 col-md-6 col-sm-6 p-0 pb-2 pb-1 order-0 order-md-1 order-sm-1 align-self-center text-center">
                    <img
                        :src="internetLiveBoxBlock.visual.url"
                        class="img-fluid w-100"
                        :alt="internetLiveBoxBlock.visual.alt"
                    >
                </div>

                <div class="col-12 col-lg-4 col-md-6 col-sm-6 p-0 ps-0 pe-md-1 pe-sm-1 ps-lg-2 pb-2 order-2">
                    <p
                        v-if="internetLiveBoxBlock.secondAttribute.icon"
                        class="icon text-white mb-0"
                        :class="internetLiveBoxBlock.secondAttribute.icon"
                        style="font-size: 1.8rem"
                        aria-hidden="true"
                    />
                    <h3 class="h4 mb-0 pt-0 text-primary" v-html="internetLiveBoxBlock.secondAttribute.label" />
                    <p class="mb-0 text-white" v-html="internetLiveBoxBlock.secondAttribute.description" />
                </div>

                <div class="col-12 col-lg-4 col-md-6 col-sm-6 p-0 pb-2 order-3">
                    <p
                        v-if="internetLiveBoxBlock.thirdAttribute.icon"
                        class="icon text-white mb-0"
                        :class="internetLiveBoxBlock.thirdAttribute.icon"
                        style="font-size: 1.8rem"
                        aria-hidden="true"
                    />
                    <h3 class="h4 mb-0 pt-0 text-primary" v-html="internetLiveBoxBlock.thirdAttribute.label" />
                    <p class="mb-0 text-white" v-html="internetLiveBoxBlock.thirdAttribute.description" />
                </div>

                <div
                    v-for="(otherAttr, otherIndex) in internetLiveBoxBlock.otherAttributes"
                    :key="'other-' + otherIndex"
                    class="col-12 col-lg-4 col-md-6 col-sm-6 p-0 pb-2"
                    :class="`order-${4 + otherIndex}`"
                >
                    <p
                        v-if="otherAttr.icon"
                        class="icon text-white mb-0"
                        :class="otherAttr.icon"
                        style="font-size: 1.8rem"
                        aria-hidden="true"
                    />
                    <h3 class="h4 mb-0 pt-0 text-primary" v-html="otherAttr.label" />
                    <p class="mb-0 text-white" v-html="otherAttr.description" />
                </div>
            </div>

            <RepeaterBlock :repeater-bloc-dto="repeaterBlocDto" />
        </div>
    </div>
</template>
